import { useAppSelector } from '@/store/hooks';
import { selectAiEmailEnabled } from '@/store/slices/feature-flags/selectors';

export const useAiEmail = () => {
  return useAppSelector(selectAiEmailEnabled);
};
